import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxAlertsService } from '@ngx-plus/ngx-alerts';
import { ApiService } from 'src/app/service/apiServices';
declare var jquery: any;
declare var $: any;
import Swal from 'sweetalert2';
import { Global } from '../../../global';
import { AuthService } from '../../../service/auth/auth.service'

@Component({
  selector: 'app-prioridade-senha-list',
  templateUrl: './prioridade-senha-list.component.html',
  styleUrls: ['./prioridade-senha-list.component.css']
})
export class PrioridadeSenhaListComponent implements OnInit {

  listPrioridades: any = [];
  filtroNome: string = "";
  filtroAtivo: any = null;
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private alerts: NgxAlertsService,
    private router: Router,
    private global: Global,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.getListPrioridades();
  }

  confirmationAtivarDesativar = (id, ativo) => {
    Swal.fire({
      title: 'Atenção',
      text: `Tem certeza que deseja ${ativo ? "ativar" : "desativar"} essa Prioridade?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#dc3545'
    }).then(
      result => {
        if (result.isConfirmed) {
          Swal.fire('Favor aguarde');
          Swal.showLoading();
          this.service.AtivarDesativar(`PrioridadeSenha/${id}`, ativo).then((res) => {
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Sucesso!',
              html: 'Operação realizada com sucesso!'
            }).then(
              result => {
                if (result.isConfirmed) {
                  this.getListPrioridades();
                }
              }
            );
          }).catch((err) => {
            Swal.close();
            if (err && err.error && err.error.erros && err.error.erros[0]) {
              Swal.fire({
                icon: 'error',
                title: 'Erro',
                html: err.error.erros[0].messagem
              });
            } else {
              Swal.fire({
                icon: 'error',
                title: 'Erro',
                html: 'Ocorreu um erro ao processar a solicitação'
              });
            }
          })
        }
      }
    );
  }

  emitError = (error) => {
    if (typeof error == 'string') {
      Swal.fire('Erro', `${error}`, 'error');
      return
    }
    if (error.status == 401 || error.error.status == 401) {
      Swal.close()
      this.authService.logoutUser()
    }
    if (error.status === 404) {
      Swal.fire('Atenção', `${error.error}`, 'warning');
      return
    }
    if (error.status) {
      Swal.fire({ icon: 'error', title: 'Erro', html: `${error.status} - ${error.error.erros[0].messagem}` })
      return
    }
    if (error.alert) {
      Swal.fire('Atenção', `${error.txt}`, 'warning');
      return
    }
  }

  emitAlert = () => {
    Swal.close()
    this.alerts.notifyError({
      body: `Erro`,
      title: 'Erro'
    });
  }

  getListPrioridades = () => {
    Swal.fire({
      title: 'Favor aguarde',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    Swal.showLoading();

    var url = `PrioridadeSenha`;
    var params: string[] = [];

    if (this.filtroNome) {
      params.push(`nome=${this.filtroNome}`);
    }

    if (this.filtroAtivo !== null && this.filtroAtivo !== undefined && this.filtroAtivo !== '') {
      params.push(`ativo=${this.filtroAtivo}`);
    }

    if (params.length > 0) {
      url = url + '?' + params.join('&');
    }

    this.service.Get(url).then(res => {
      this.listPrioridades = res || [];
      Swal.close();
      this.loading = false;
    }).catch(res => {
      this.listPrioridades = [];
      Swal.close();
      this.loading = false;

      if (res && res.status == 401 || (res && res.error && res.error.status == 401)) {
        this.authService.logoutUser()
        return;
      }

      if (res && res.error && res.error.erros && res.error.erros[0]) {
        Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
      } else {
        Swal.fire('Erro', 'Ocorreu um erro ao buscar as prioridades', 'error');
      }
    });
  }

  obterListaFiltros() {
    this.getListPrioridades();
  }

  limparFiltros() {
    this.filtroNome = "";
    this.filtroAtivo = null;
    this.getListPrioridades();
  }
}
